import React from "react";
import { ArrowRight } from "lucide-react";
import { company, pillars } from "../mock";

export default function Hero() {
  return (
    <section id="top" className="section-cream grain">
      <div className="max-w-7xl mx-auto px-6 md:px-10 pt-16 md:pt-24 pb-20 md:pb-28">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16">
          <div className="lg:col-span-7">
            <p className="eyebrow eyebrow-line">Owner-side Property Consultancy</p>
            <h1 className="font-serif-display mt-6 text-[2.6rem] sm:text-[3.4rem] md:text-[4.2rem] lg:text-[4.6rem] leading-[1.02] text-[#2a3325]">
              Considered stewardship
              <br />
              <span className="italic-accent">of cross-border</span>
              <br />
              property holdings.
            </h1>
            <p className="mt-8 max-w-xl text-[#3d4838] text-[0.98rem] leading-[1.75] font-light">
              {company.name} works on the owner’s side of the table for private investors and absentee landlords holding property away from home. Independent counsel, layout and yield strategy, and remote programme oversight — a US practice with its working bench in prime London.
            </p>

            <div className="mt-10 flex flex-wrap items-center gap-5">
              <a href="#contact" className="btn-dark">
                Book a Consultation <ArrowRight className="w-4 h-4" />
              </a>
              <a href="#services" className="btn-ghost">
                See how we work <ArrowRight className="w-4 h-4" />
              </a>
            </div>
          </div>

          <div className="lg:col-span-5 lg:pl-8 lg:pt-16">
            <div className="divider mb-6" />
            <ul className="space-y-8">
              {pillars.map((p) => (
                <li key={p.n} className="flex gap-6">
                  <span className="font-serif-display italic-accent text-lg leading-none pt-1">{p.n}</span>
                  <div>
                    <p className="font-serif-display text-xl text-[#2a3325]">{p.title}</p>
                    <p className="mt-1.5 text-[#4d5a45] text-sm leading-relaxed">{p.desc}</p>
                  </div>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}
